import { createIcon } from '@chakra-ui/react';

export const VisaCard = createIcon({
  displayName: 'Visa Card',
  viewBox: '0 0 32 32',
  path: (
    <path
      id="Visa_Card_-_Mono-2"
      data-name="Visa Card - Mono"
      d="M11.855,18.99l-1.4,2.45a5.82,5.82,0,0,0-.67,1.37h0c.025-.5-.045-1.145-.055-1.5L9.57,18.99H6.92l-.03.155A1.09,1.09,0,0,1,8.08,20.18l.5,4.585H10.2L13.48,18.99Zm2.455,0-1.755,5.775H14.12l1.75-5.78ZM27.66,11.8H4.84A4.34,4.34,0,0,0,.5,16.13V27.66A4.34,4.34,0,0,0,4.84,32H27.66A4.34,4.34,0,0,0,32,27.66V16.13a4.34,4.34,0,0,0-4.34-4.34Zm2.85,15.87a2.85,2.85,0,0,1-2.85,2.85H4.84a2.85,2.85,0,0,1-2.85-2.85V16.13a2.85,2.85,0,0,1,2.85-2.85H27.66a2.85,2.85,0,0,1,2.85,2.85Zm-7.5-8.66-3.085,5.76h1.7l.4-.87h1.955l.045.86h1.59l-.5-5.765Zm-.46,3.84.585-1.27c.18-.42.585-1.285.685-1.57h0a12.3,12.3,0,0,0,0,1.355l.08,1.5ZM18.8,21.4l-.36-.23c-.5-.3-.69-.5-.525-.84a.725.725,0,0,1,.665-.3,1.9,1.9,0,0,1,1.215.53l.855-1a3.5,3.5,0,0,0-2.035-.7,2.169,2.169,0,0,0-2.18,1.155c-.425,1.025-.035,1.61.875,2.23l.3.195c.61.35.88.55.66.925a.72.72,0,0,1-.685.33A2.865,2.865,0,0,1,15.9,23.13l-.745,1.14a4.385,4.385,0,0,0,2.36.66,2.263,2.263,0,0,0,2.37-1.43C20.16,22.82,19.9,22.09,18.8,21.4Z"
      transform="translate(-0.25 -5.895)"
      fill="currentColor"
    />
  ),
});
